import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>About us</h2>
        <p>
          At House of Hope, we make it our goal to serve as many women and
          children as we possibly can. We believe recovery is possible for
          anyone who wants it, regardless of the obstacles that may stand in the
          way. We help women to realize their potential and instill hope in them
          that they can recover.
        </p>
        <p>
          Founded in 1946 and formerly known as The Utah Alcoholism Foundation
          (UAF), House of Hope is the oldest provider of alcohol and chemical
          dependency treatment services in Utah providing a continuum of
          residential, day treatment, outpatient, and aftercare services
          throughout the state. Over the years, House of Hope has grown to meet
          the needs of communities throughout Utah.
        </p>

        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/-tyYoaWs9nE"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        
        <br />
        <br />
        <a
          href="https://g.co/kgs/F1xxCNJ"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit House of Hope Salt Lake City
        </a>
        <br />
        <br />
        <a
          href="https://g.co/kgs/LLGEfHF"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vist House of Hope Provo
        </a>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
